import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";

export default function useAddChatHistory() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  function addChatHistory(formData, setLoading, onSuccess) {
    fetchWrapper({
      endpoint_url: "chat_history/addChatHistory",
      setLoading: setLoading,
      set_content_type_header: false,
      body: formData,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          onSuccess();
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "add chat history" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "add chat history" });
      },
    });
  }

  return { addChatHistory };
}
